module.exports = __webpack_public_path__ + "static/img/ghs.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ghs.png
// module id = OPZa
// module chunks = 1